module.exports = __webpack_public_path__ + "media/anna.d9e30455.mp4";